export default __webpack_public_path__ + "static/media/book-stack-icon.599e73da.svg";